import { Directive, ElementRef, Input, OnChanges } from "@angular/core";

@Directive({
    standalone: false,
    selector: "input[type=checkbox][indeterminate]",
})
export class IndeterminateDirective implements OnChanges {
    @Input() indeterminate: boolean;

    constructor(private el: ElementRef<HTMLInputElement>) {}

    ngOnChanges() {
        this.el.nativeElement.indeterminate = this.indeterminate;
    }
}
